// Import helpers
import { CURRENT_OPERATOR, isRetail, CURRENT_SYSTEM } from 'helpers/operators';

// Import hooks
import { useAppSelector } from 'store/hooks';
import { useAuth } from 'components/utilities';

// Import types
import { Systems } from 'types/api/systems';

function useOperators() {
	const { isAuth } = useAuth();

	const source = useAppSelector(({ subscriber }) => subscriber.details?.source);

	const isOperator = !isRetail;
	const isRetailUser = source === Systems.Retail && isRetail;
	const isRetailOrGuest = isRetailUser || !isAuth;

	return {
		isLogged: isAuth,
		isRetailUser: isRetailUser,
		isRetailOrGuest,
		source,
		operator: CURRENT_OPERATOR,
		operatorSystem: CURRENT_SYSTEM,
		isOperator
	};
}

export default useOperators;
